/**
 * Модульный стор UI-состояния раздела «Аналитика»: активная вкладка, период и
 * состояние таблиц (сортировка + фильтры). Нужен, чтобы при переходе в карточку/
 * историю заявки и возврате НАЗАД (клиентская навигация без перезагрузки) не
 * сбрасывались ни выбранная вкладка (иначе всегда открывалась «Сводка»), ни
 * набранные фильтры/сортировка, ни выбранный период.
 *
 * Живёт в памяти JS-контекста SPA — переживает навигацию, сбрасывается только при
 * полной перезагрузке страницы (это ожидаемо: «свежий» вход = состояние по
 * умолчанию).
 */

export interface AnalyticsPeriodState {
  periodKey: string
  date: string
  from: string | null
  to: string | null
}

export interface AnalyticsTableState {
  sortKey: string | null
  sortDir: 'asc' | 'desc'
  /** key колонки → выбранные значения фильтра (Set сериализован в массив). */
  filters: Record<string, string[]>
}

interface AnalyticsUiStore {
  tab?: string
  period?: AnalyticsPeriodState
  tables: Record<string, AnalyticsTableState>
}

const store: AnalyticsUiStore = { tables: {} }

export const analyticsUi = {
  getTab: (): string | undefined => store.tab,
  setTab: (tab: string): void => {
    store.tab = tab
  },
  getPeriod: (): AnalyticsPeriodState | undefined => store.period,
  setPeriod: (p: AnalyticsPeriodState): void => {
    store.period = p
  },
  getTable: (key: string): AnalyticsTableState | undefined => store.tables[key],
  setTable: (key: string, s: AnalyticsTableState): void => {
    store.tables[key] = s
  },
}
